import { Component, Input, Output, OnInit, NgZone } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, Platform , NavController} from '@ionic/angular';

import { InAppBrowser, InAppBrowserEvent } from '@ionic-native/in-app-browser/ngx';

import { CommonService, UserService, AuthService, BackendService, FirebaseService,ApiService, HelperService } from '../../../providers/index';
import { HttpClient } from '@angular/common/http';
import { LoadingController, ToastController } from '@ionic/angular';
declare const fbq;
declare const _paq;
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-ordercard-single',
  templateUrl: './ordercard-single.html',
  styleUrls: ['./ordercard-single.scss'],
})

export class OrdercardsingleComponent implements OnInit {

  @Input() options: any;
  item: any = {};
  order: any = {};
  // minDate: string;
maxDate: string;
  searchspecies_id = 0;
  isDownloading = false;
  isCheckoutPage: boolean = false;
  public isMenuOpen: boolean = false;
  deliverytimeslots: any[] = [];
  loadingSlots = false;
  
  tempNewSlotId: any = null;
  tempNewSlotName: string = null;
  
  isRescheduleModalOpen = false;
  tempNewDate: string;
  minDate = new Date().toISOString(); // Only allow today onwards

  isThankYouPage = false;
isOrdersListPage = false;

  iabloaded = false;
  browser: any;
  interval2: any;
  bwindow: any;
  initpayment = false;
  appsettings: any;
  loading: boolean;
  constructor(
    public alertCtrl: AlertController,
    public router: Router,
    public route: ActivatedRoute,
    public commonService: CommonService,
    public firebaseService: FirebaseService,
    private iab: InAppBrowser,
    public apiService: ApiService,
    private zone: NgZone,
    private helperService: HelperService,
    private http: HttpClient, // Inject the HttpClient
    private loadingController: LoadingController, // For a nice loading spinner
    private toastController: ToastController, // For user feedback
    private platform: Platform, private navCtrl: NavController
    ) {

      this.platform.ready().then(() => {
        console.log('Platform ready, iab available');
      });

  }

  ngOnInit(): void {

//     const url = this.router.url;

// this.isCheckoutPage = url.includes('checkout');
// this.isThankYouPage = url.includes('thankyou') || this.initpayment;
// this.isOrdersListPage = url.includes('/orders');


const url = this.router.url;

this.isCheckoutPage = url.includes('checkout');
this.isOrdersListPage = url.includes('/orders');
this.isThankYouPage = url.includes('thankyou');

// initpayment is separate and will be set from options


// Check if the current URL contains 'checkout'
    this.isCheckoutPage = this.router.url.includes('checkout');
     this.route.params.subscribe(params => {
      const orderId = params['id'];
      if (orderId) {
        this.fetchOrderDetails(orderId);
      }
    });

    // //console.log(this.options);
    // this.items = ['nikhil', 'ganesh'];
    if (this.options) {
      //console.log(this.options);
      this.item = this.options.item;
      this.order = this.options.order;
      this.order.debugjson = JSON.parse(this.order.debugjson);

      if (this.options.initpayment) {
        this.initpayment = true;
        if (!this.order.payment_refno) {
          this.payWithPayu(true);
        }


      }

      // if(this.order.payment_refno){
      // this.logpurchaseevent();
      // }

      //TEST PURCHASE EVENT else{
      // let bforder:any=this.order;
      // bforder.value=this.order.total;
      // bforder.transaction_id=this.order.id;
      // this.commonService.FirebaseService.logbfevent('purchase',bforder);
      // }

    }
    this.appsettings = JSON.parse(localStorage.getItem('appsettings'));
  }

  ionViewWillLeave() {
    //console.log('stopping ping');
    if (this.interval2) {
      clearInterval(this.interval2);
    }
  }

  async reorder() {
    // ✅ ensure appsettings ready (APK issue)
    if (!this.appsettings?.products?.length) {
      this.appsettings = JSON.parse(localStorage.getItem('appsettings'));
    }
    if (!this.appsettings?.products?.length) {
      this.helperService.presentToast('error', 'App data not loaded. Please try again.');
      return;
    }
  
    // ✅ clear EVERYTHING
    this.commonService.cart_clear();

    
  
    // ✅ hard reset multi-delivery leftovers (persistent cart issue)
    delete this.commonService.cart['all_schedules'];
    delete this.commonService.cart['schedules_in_body'];
    delete this.commonService.cart['cart_finaltotal'];
    delete this.commonService.cart['finaltotal'];
    delete this.commonService.cart['express_charge'];
    delete this.commonService.cart['is_express_delivery'];
  
    // ✅ new items array
    this.commonService.cart.items = [];
  
    // ✅ HARD RESET totals + multi-delivery globals (APK keeps old memory sometimes)
    this.commonService.selectedDays = 1;
    this.commonService.expressSlotCount = 0;
    this.commonService.is_express_delivery = false;

    this.commonService.cart.total = 0;
    this.commonService.cart.quantity = 0;
    this.commonService.cart.delivery_charge = 0;

    this.commonService.cart.all_schedules = [];
    this.commonService.cart.schedules_in_body = 0;
    this.commonService.cart.express_slot_count = 0;
    this.commonService.cart.express_charge = 0;
    this.commonService.delivery_charge = 0;


    // ✅ IMPORTANT: flush empty cart to storage FIRST (fixes APK re-hydration bug)
    this.commonService.cart_update();

    // ✅ deep clone each item (fix random behavior)
    for (const c of this.order.debugjson.cart.items) {
      const cloned = JSON.parse(JSON.stringify(c));
      await this.checkisinstock(cloned);
    }
  
    // ✅ reset delivery meta
    this.commonService.cart.deliverydate = null;
    this.commonService.cart.deliverytimeslot = null;
    this.commonService.cart.deliverytimeslot_id = null;
    this.commonService.cart.deliverytimeslot_name = null;
  
    // ✅ reset multi delivery defaults
    // this.commonService.cart.all_schedules = [];
    // this.commonService.cart.schedules_in_body = 0;
    // this.commonService.cart.is_express_delivery = false;
    // this.commonService.cart.express_charge = 0;
  
    // ✅ reset discount/address/payment
    this.commonService.cart.coupon_code = null;
    this.commonService.cart.offer_code = null;
    this.commonService.cart.address_id = null;
    this.commonService.cart.payment_mode = null;
    this.commonService.cart.is_pod = null;
  
    this.commonService.cart_update();
    this.commonService.resetCheckoutState(); // 👈 add this
  
    // ✅ (optional) tiny delay helps native storage settle
    // setTimeout(() => {
    //   this.router.navigateByUrl('/checkout');
    // }, 50);
    this.navCtrl.navigateRoot('/checkout', {
      
      replaceUrl: true
    });
    
    
  }

  
  

  async checkisinstock(item){
    let tempproduct = await this.appsettings.products.filter(p=> p._id == item._id);
    if(tempproduct.length>0){
      if(tempproduct[0].is_stock){     
      
        if(tempproduct[0].price != item.price){
          this.helperService.presentToast('error','Price of '+item.name +' is updated to '+tempproduct[0].price);
          item.price = tempproduct[0].price;
        }
        tempproduct[0]['quantity'] = item.quantity;
        item.finalprice = item.price;
        let canshowpricing = true;

        if (item.is_customizable && item.productcustomization_data) {
          item.productcustomization_data.forEach(element => {
            if (element.type == 'radio') {
              if (element.value) {
                item.finalprice = parseInt(item.finalprice) + parseInt(element.value.price);
                console.log(item);
                canshowpricing = true;
              } else {
                canshowpricing = false;
              }
            }
    
            if (element.type == 'toggle') {
              if (element.value == true) {
                item.finalprice = parseInt(item.finalprice) + parseInt(element.price);
    
              }
            }
    
    
          });
        }

        this.commonService.cart_add(item);
        return true;
      }else{
        this.helperService.presentToast('error',item.name +' is out of stock');
        return false 
      }
    }else{
      return false;
    }
  }


  // isDateEnabled = (dateIsoString: string) => {
  //   const date = new Date(dateIsoString);
  
  //   // ❌ Disable Monday
  //   if (date.getDay() === 1) return false;
  
  //   // ❌ Disable same date as current delivery date
  //   const current = this.order?.deliverydate;
  //   if (current) {
  //     const currentDate = this.commonService.safaridatefix(current)
  //       .toISOString()
  //       .split('T')[0];
  
  //     const selectedDate = new Date(dateIsoString).toISOString().split('T')[0];
  
  //     if (selectedDate === currentDate) return false;
  //   }
  
  //   return true;
  // };
  
  isDateEnabled = (dateIsoString: string) => {
    const date = new Date(dateIsoString);
  
    // ❌ Disable Monday
    if (date.getDay() === 1) return false;
  
    return true;
  };

  
  
  async onRescheduleDateSelect(ev: any) {
    const val = ev?.detail?.value;
    console.log("🟦 [onRescheduleDateSelect] raw:", val);
  
    this.tempNewDate = val;
  
    // ✅ reload slots for new date
    await this.loadRescheduleSlots(this.tempNewDate);
  
  // ❌ Do NOT reset slot for EXPRESS
    if (!this.isExpressDelivery()) {
      const stillValid = this.deliverytimeslots?.some(
        s => s._id === this.tempNewSlotId
      );

      if (!stillValid) {
        this.tempNewSlotId = null;
        this.tempNewSlotName = null;
        return;
      }
    }

  
    // ✅ otherwise keep and sync name
    this.syncTempSlotNameFromId();
  }
  

  onRescheduleSlotSelect(ev: any) {
    const slotId = ev?.detail?.value;
    console.log("🟦 [onRescheduleSlotSelect] RAW:", slotId);
  
    this.tempNewSlotId = slotId;
    this.syncTempSlotNameFromId();
  }
  
  
  async confirmReschedule() {
    if (!this.tempNewDate || !this.tempNewSlotId) {
      this.commonService.notify('info', 'Select Date & Slot', 'Please select both.');
      return;
    }
  
    // --- FIX START ---
    // OLD CODE (Causes earlier date issue due to Timezone conversion):
    // const newDateSafe = this.commonService.safaridatefix(this.tempNewDate);
    // const newDate = newDateSafe.toISOString().split('T')[0];
  
    // NEW CODE (Takes the date string directly as is):
    let newDate = this.tempNewDate;
    
    // If it comes as "2023-01-01T14:30...", split it to get "2023-01-01"
    if (typeof newDate === 'string' && newDate.includes('T')) {
        newDate = newDate.split('T')[0];
    }
    // --- FIX END ---
  
    // Handle Old Date (Safe to keep this as it reads from existing order)
    const oldDateSafe = this.commonService.safaridatefix(this.order.deliverydate);
    const oldDate = oldDateSafe.toISOString().split('T')[0];
  
    const oldSlotId =
      this.order?.deliverytimeslot ||
      this.order?.deliverytimeslot_id ||
      this.order?.debugjson?.deliverytimeslot?._id ||
      null;
  
    const isSameDate = oldDate === newDate;
    const isSameSlot = oldSlotId == this.tempNewSlotId;
  
    if (isSameDate && isSameSlot) {
      this.commonService.notify('info', 'No Change', 'Same date & slot selected.');
      return;
    }
  
    const slot = this.deliverytimeslots?.find(s => s._id === this.tempNewSlotId);
  
    const alert = await this.alertCtrl.create({
      header: 'Confirm Reschedule',
      message: `Are you sure you want to reschedule your delivery to <b>${newDate}</b> between <b>${slot?.name || ''}</b>?`,
      buttons: [
        { text: 'No', role: 'cancel' },
        {
          text: 'Yes, Update',
          handler: () => {
            this.isRescheduleModalOpen = false;
            // Pass the corrected newDate string directly
            this.executeDateTimeUpdate(newDate, this.tempNewSlotId, oldDate);
          }
        }
      ]
    });
  
    await alert.present();
  }


async loadRescheduleSlots(dateIso: string) {
  try {
    this.loadingSlots = true;

    const dateForApi = (dateIso || '').replace(/-/g, '/');

    const schedules = this.order?.debugjson?.cart?.items || [];
    const speciesIds = schedules
      .map((it: any) => it?.species?._id)
      .filter(Boolean);

    const params: any = {
      species: speciesIds.toString(),
      date: dateForApi
    };

    const res: any = await this.apiService
      .callapi(this.apiService.APIS.ADMIN_AVAILABLETIMESLOTS, params)
      .toPromise();

    const isExpressOrder = this.isExpressDelivery();

    this.deliverytimeslots = (res?.deliverytimeslots || []).map(slot => {

      // 🟥 CASE-1: Order is EXPRESS → LOCK time slot
      if (isExpressOrder) {
        return {
          ...slot,
          disabled: slot._id !== this.tempNewSlotId
        };
      }

      // 🟥 CASE-2: Order is NON-EXPRESS → block express slots
      if (
        slot?.is_express ||
        String(slot?.name || '').toLowerCase().includes('express')
      ) {
        return { ...slot, disabled: true };
      }

      return slot;
    });

  } catch (e) {
    this.deliverytimeslots = [];
    this.commonService.notify('error', 'Unable to load slots', 'Please try again.');
  } finally {
    this.loadingSlots = false;
  }
}

 syncTempSlotNameFromId() {
    const selected = this.deliverytimeslots?.find(s => s._id === this.tempNewSlotId);
    this.tempNewSlotName = selected?.name || null;
  
    console.log("🟦 [syncTempSlotNameFromId]", {
      tempNewSlotId: this.tempNewSlotId,
      tempNewSlotName: this.tempNewSlotName
    });
  }
  
  async openRescheduleModal() {
    this.setMinMaxRescheduleDate();
  
    // current values from order
    const currentDate = this.order?.deliverydate;
    const currentSlotId =
      this.order?.deliverytimeslot ||                 // ✅ your order has this
      this.order?.deliverytimeslot_id ||              // fallback
      this.order?.debugjson?.deliverytimeslot?._id || // fallback
      null;
  
    const currentSlotName =
      this.order?.deliverytimeslot_name ||
      this.order?.debugjson?.deliverytimeslot?.name ||
      null;
  
    // ✅ prefill temp values (so chips show immediately)
    // this.tempNewDate = currentDate
    //   ? this.commonService.safaridatefix(currentDate).toISOString().split('T')[0]
    //   : null;

    // ✅ THIS KEEPS THE CORRECT LOCAL DATE (e.g. 19th stays 19th)
if (currentDate) {
  const d = this.commonService.safaridatefix(currentDate);
  // Manually build YYYY-MM-DD using local time methods
  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);
  this.tempNewDate = `${year}-${month}-${day}`;
} else {
  this.tempNewDate = null;
}
  
    this.tempNewSlotId = currentSlotId;
    this.tempNewSlotName = currentSlotName; // ✅ show immediately (even before slots load)
  
    this.deliverytimeslots = [];
    this.loadingSlots = false;
  
    this.isRescheduleModalOpen = true;
  
    // ✅ load slots for preselected date
    if (this.tempNewDate) {
      await this.loadRescheduleSlots(this.tempNewDate);
  
      // ✅ after slots load, sync name from list (this also fixes mismatches)
      this.syncTempSlotNameFromId();
    }
  
    console.log("🟩 [openRescheduleModal] PREFILL", {
      tempNewDate: this.tempNewDate,
      tempNewSlotId: this.tempNewSlotId,
      tempNewSlotName: this.tempNewSlotName
    });
  }
  

closeRescheduleModal() {
  this.isRescheduleModalOpen = false;
  this.tempNewDate = null;
  this.tempNewSlotId = null;
  this.tempNewSlotName = null;
  this.deliverytimeslots = [];
  this.loadingSlots = false;
}



setMinRescheduleDate() {
  const now = new Date();

  // add 1 day (24 hours rule)
  now.setDate(now.getDate() + 1);

  this.minDate = now.toISOString().split('T')[0];
}


async executeDateTimeUpdate(newDate: string, newSlotId: any, oldDate: string) {
  await this.commonService.showLoader("Updating delivery...");

  // ✅ find slot name once and send to backend
  const slot = this.deliverytimeslots?.find(s => s._id === newSlotId);
  const slotName = slot?.name || this.tempNewSlotName || "";

  const payload: any = {
    order_id: this.order._id,
    new_delivery_date: newDate,
    new_deliverytimeslot_id: newSlotId,
    new_deliverytimeslot_name: slotName, // ✅ IMPORTANT
  };

  // console.log("🟥 [executeDateTimeUpdate] PAYLOAD:", payload);

  this.http.post(this.commonService.getApiUrl() + '/order/updateOrderDate', payload)
    .subscribe(
      (res: any) => {
        this.commonService.hideLoader();

        // console.log("🟩 [executeDateTimeUpdate] RESPONSE:", res);

        if (res?.status === 'success') {
          this.zone.run(() => {

            // ✅ Update UI from backend response (best)
            this.order.deliverydate = res.data.deliverydate || newDate;
            this.order.deliverytimeslot = res.data.deliverytimeslot;
            this.order.deliverytimeslot_name = res.data.deliverytimeslot_name;
            
            // force refresh
            this.order = { ...this.order };

            // reset modal temp
            this.tempNewDate = null;
            this.tempNewSlotId = null;
            this.tempNewSlotName = null;
            this.deliverytimeslots = [];
          });

          this.commonService.notify('info', 'Delivery updated successfully.');
        } else {
          this.commonService.notify('error', 'Update failed', 'Please try again.');
        }
      },
      (err) => {
        this.commonService.hideLoader();
        // console.log("🟥 [executeDateTimeUpdate] ERROR:", err);
        this.commonService.notify('error', 'Error', 'Server error');
      }
    );
}



setMinMaxRescheduleDate() {
  const today = new Date();

  // ✅ Minimum = Tomorrow
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  this.minDate = tomorrow.toISOString().split('T')[0];

  // ✅ Maximum = End of next 6th month
  // Same pattern as checkout
  const sixMonthsLater = new Date(
    today.getFullYear(),
    today.getMonth() + 6,
    1
  );

  sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 1);
  sixMonthsLater.setDate(0); // last day of that month

  this.maxDate = sixMonthsLater.toISOString().split('T')[0];
}





// canReschedule(deliveryDate: string): boolean {
//   if (
//     !deliveryDate ||
//     this.order?.is_cancelled == 1 ||
//     this.order?.delivery_status == 'delivered'
//   ) {
//     return false;
//   }

//   const now = new Date();

//   // ✅ SAFELY parse delivery date
//   const delivery = this.commonService.safaridatefix(deliveryDate);

//   const diffInMs = delivery.getTime() - now.getTime();
//   const diffInHours = diffInMs / (1000 * 60 * 60);

//   return diffInHours > 24;
// }

canReschedule(deliveryDate: string): boolean {
  if (
    !deliveryDate ||
    this.order?.is_cancelled == 1 ||
    this.order?.delivery_status == 'delivered'
  ) {
    return false;
  }

  // Parse delivery date safely (keeps your existing safari fix behavior)
  const delivery = this.commonService.safaridatefix(deliveryDate);

  // Cutoff = previous day 23:59:59.999 (i.e., 11:59 PM)
  const cutoff = new Date(delivery);
  cutoff.setDate(cutoff.getDate() - 1);
  cutoff.setHours(23, 59, 59, 999);

  const now = new Date();

  // Enable only until cutoff time
  return now.getTime() <= cutoff.getTime();
}

  payWithPayu(trackevent = false) {

    if (this.interval2) {
      clearInterval(this.interval2);
    }

    if (this.order.payment_refno) {
      this.commonService.notify('Please Wait', 'We are processing your order');
      return 0;
    }

    //console.log(this.order);
    //console.log(this.commonService.tmppod);

    if (this.order.is_pod == 1 && this.commonService.tmppod == 0) {
      this.logpurchaseevent();
      //console.log('payment on delivery');
      this.commonService.tmppod = 1;
      if (trackevent) {
        _paq.push(['trackEvent', 'Payment', 'Cash on Delivery', 'Success', this.order._id]);
      }

      return 0;
    }


    _paq.push(['trackEvent', 'Payment', 'Online', 'Initiated', this.order._id]);


    // let pgurl = this.commonService.apiUrl + '/payu/pg/?order_id=' + this.order._id;
    //new for diff id
      let paymode = 'single';

      // ✅ If coming from checkout thankyou/initpayment => combined payment
      if (this.isCheckoutPage || this.initpayment) {
        paymode = 'checkout';
      }

      let pgurl = this.commonService.apiUrl + '/payu/pg/?order_id=' + this.order._id + '&paymode=' + paymode;

      console.log("🔗 PayU URL:", pgurl, "order:", this.order._id, "paymode:", paymode);

    
    //check if onnative app 
    if (!localStorage.getItem('onesignal')) {
      
     
        const check = setInterval(() => {
          if (this.iab) {
            clearInterval(check);
            this.browser = this.iab.create(pgurl,'_blank','location=yes,hideurlbar=yes');
            this.iabloaded = true;
            this.browser.on('beforeload').subscribe((event: InAppBrowserEvent) => {
              console.log('Loading URL:', event);
              if (event.url.startsWith('http://upi')) {
      
                //this.browser.load
                // Change the URL to the new URL
                //window.open(event.url, '_system');
      
              }
            });        
          }
        }, 100); // check every 100ms 
      
    
    } else {
      
      this.browser = this.iab.create(pgurl, '_blank');
      try {
        this.browser.on('exit').subscribe(event => {
          if (!this.order.payment_refno) {
            //this.showpaymentalertmessage=true;
          }

        });
      } catch (error) {
        //console.log(error);
      }
     
    }

    this.commonService.activecheckingorderid = this.order._id;
    this.interval2 = setInterval(() => {
      this.checkOrderStatus();
    }, 4000);

  }


  checkOrderStatus() {
    //disble pinginterbal if check fix
    if (this.commonService.activecheckingorderid != this.order._id) {
      if (this.interval2) {
        clearInterval(this.interval2);
      }
    }
    let params: any = {};
    // params.type=type;

    this.apiService.callapi(this.apiService.APIS.ORDER_CHECKORDERSTATUS, { id: this.order._id })
      .subscribe(
        data => {
          if (data) {
            data.debugjson = JSON.parse(data.debugjson);
            if (data.payment_refno) {
              this.order = data;
              this.order.payment_refno = data.payment_refno;
              if (this.iabloaded) {
                this.browser.close();
                this.iabloaded = false;
                
              }
              if (this.bwindow) {
                //console.log('calling close');
                this.bwindow.close();
              }
              this.commonService.notify('info', 'Payment Successfull');

              _paq.push(['trackEvent', 'Payment', 'Online', 'Success', this.order._id]);

              this.logpurchaseevent();

              //this.clearIntervalping();
              if (this.interval2) {
                clearInterval(this.interval2);
              }
            }else if(data.payment_status == 'failure'){
              this.order = data;
              this.order.is_cancelled = data.is_cancelled;
              if (this.iabloaded) {
                this.browser.close();
                this.iabloaded = false;
                
              }
              if (this.bwindow) {
                //console.log('calling close');
                this.bwindow.close();
              }
              this.commonService.notify('info', 'Payment Failed');

              _paq.push(['trackEvent', 'Payment', 'Online', 'Failure', this.order._id]);
              this.logpurchaseevent();

              //this.clearIntervalping();
              if (this.interval2) {
                clearInterval(this.interval2);
              }
            }
             else {
              //disable ping if 
              //this.checkOrderStatus();

            }
          }
        },
        error => {

          // this.loading = false;

        });
  }


  async cancel_order_prompt() {
    const alert = await this.alertCtrl.create({
      cssClass: 'my-custom-class',
      header: 'Are you sure to Cancel Order #' + this.order._id,
      message: 'Please refer FAQs for Cancellation , returns and refund Policies.',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            //console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Yes - Confirm Canellation',
          handler: () => {
            this.cancel_order();
            //console.log('Confirm Okay');
          }
        }
      ]
    });

    await alert.present();
  }


  cancel_order() {
    let model: any = {};
    model._id = this.order._id;
    model.is_cancelled = 1;
    this.apiService.callapi(this.apiService.APIS.ORDER_CANCEL, { _id: this.order._id, is_cancelled: 1 })
      .subscribe(
        data => {
          this.zone.run(()=>{
            this.order.is_cancelled = 1;
            //this.order.delivery_status = 'cancelled';
          })
          this.commonService.notify('info', 'Order Cancelled');
        });

  }

  logpurchaseevent() {
    let bforder: any = {};
    bforder.value = this.order.finaltotal;
    bforder.revenue = this.order.finaltotal;
    bforder.transaction_id = this.order._id;
    bforder.currency = "INR";
    //console.log('logging purchase event', bforder);

    //console.log('analyticsdata', this.order);

    _paq.push(['trackEcommerceOrder',
      this.order._id, // (Required) orderId
      this.order.finaltotal, // (Required) revenue
      this.order.finaltotal, // (Optional) subTotal
      0, // 1.5, // (optional) tax
      this.order.delivery_charge // 1, // (optional) shipping
      //false // (optional) discount
    ]);
    setTimeout(() => {


      //log payment success event
      /*if(this.order.payment_mode=='online'){
      _paq.push(['trackEvent', 'Payment', 'Online','Success']);}
      else    if(this.order.payment_mode=='cash on delivery'){
      _paq.push(['trackEvent', 'Payment', 'Cash on Delivery','Success']);
      }*/

      this.firebaseService.logbfevent('purchase', bforder);
      fbq('track', 'Purchase', bforder);

      this.commonService.cart_clear();
      _paq.push(['clearEcommerceCart']);


      //reassign session to register user in case of guest
      let cu = this.commonService.getCurrentUser();
      if (!cu) {
        //console.log('assigning session');
        //assign session to user in case of guest user
        let u: any = {};
        u.name = this.order.user_name;
        u._id = this.order.user;
        this.firebaseService.setfbuserid(u);
      }



    }, 1000);


  }

  async deliverycostInfo() {
    const alert = await this.alertCtrl.create({
      header: 'Delivery Cost Information',
      message: '',
      cssClass: 'delivery-cost-info',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
          }
        }
      ]
    });

    alert.present();
  }
  
  getFormattedAddress(address){
    let pincode = address.pincode;
    let formatted = '';
    if(!address.formatted_address.includes(pincode)) {
      let ss = address.formatted_address.split(',');
      if(ss[ss.length-2]){
        let ss1 = ss[ss.length-2].split(' ');
        if(pincode != ss1[ss1.length-1]){
          formatted ='Custome Pincode '+ pincode;
        }
      }
    }
    return formatted;
  }
  fetchOrderDetails(orderId: string) {
    this.http.get(`${environment.apiUrl}/api/orders/${orderId}`).subscribe(
      (response: any) => {
        this.order = response;
  
        if (this.order?.debugjson && typeof this.order.debugjson === 'string') {
          this.order.debugjson = JSON.parse(this.order.debugjson);
        }
      },
      error => console.error(error)
    );
  }
  

  async downloadInvoice() {
    if (!this.order || !this.order._id) {
      console.error('Download aborted: Order ID is not available.');
      this.presentToast('Order information is missing. Cannot download invoice.', 'danger');
      return;
    }

    console.log(`Initiating invoice download for Order ID: ${this.order._id}`);
    this.isDownloading = true;

    // Use a loading controller for a more polished UI experience
    const loading = await this.loadingController.create({
      message: 'Generating invoice...',
      spinner: 'crescent'
    });
    await loading.present();

    const orderId = this.order._id;
    // Replace with your actual backend URL
    const invoiceApiUrl = `${environment.apiUrl}/generate-tax-invoice?_id=${orderId}`;

    try {
      const response: any = await this.http.get(invoiceApiUrl).toPromise();
      
      console.log('Invoice generation API response:', response);
      if (response && response.pdfUrl) {
        console.log('Invoice PDF URL received:', response.pdfUrl);

        // Construct the full URL to the PDF file
        const fullPdfUrl = `${environment.apiUrl}${response.pdfUrl}`;
        console.log('Final PDF URL for download:', fullPdfUrl);

        // The simplest way to trigger a download is to open the URL
        window.open(fullPdfUrl, '_blank');
        
        this.presentToast('Invoice downloaded successfully!', 'success');
      } else {
        console.error('Invoice URL not found in the response.');
        this.presentToast('Failed to get invoice URL from the server.', 'danger');
      }
    } catch (error) {
      console.error('Error during invoice download:', error);
      this.presentToast('An error occurred while generating the invoice.', 'danger');
    } finally {
      await loading.dismiss();
      this.isDownloading = false;
    }
  }

  async presentToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      color: color,
      duration: 2000,
      position: 'bottom'
    });
    toast.present();
  }

  // getExpressCount(): number {
  //   const schedules = this.order?.debugjson?.all_schedules || [];
  //   return schedules.filter((s: any) =>
  //     (s?.slot_name || '').toLowerCase().includes('express')
  //   ).length;
  // }
  // getCheckoutGrandTotal(): number {
  //   const schedules = this.order?.debugjson?.all_schedules || [];
  //   const deliveriesCount = schedules.length || 1;
  
  //   const cartTotal = this.order?.debugjson?.cart?.total || 0;
  //   const deliveryCharge = this.order?.delivery_charge || 0;
  
  //   const expressCount = this.getExpressCount();
  
  //   const base = cartTotal + deliveryCharge;                 // per delivery base
  //   return (base * deliveriesCount) + (expressCount * 99);   // ✅ correct
  // }
  
  // getExpressAmount(): number {
  //   if (this.isCheckoutLike()) {
  //     return this.getExpressCount() * 99;
  //   }
  //   // Orders/Single card mode (old logic)
  //   return this.isExpressDelivery() ? 99 : 0;
  // }
    
  
  isThisDeliveryExpress(): boolean {
    return !!this.order?.debugjson?.deliverytimeslot?.is_express;
  }

  
  isExpressDelivery(): boolean {
    const slotName =
      this.order?.deliverytimeslot_name ||
      this.order?.debugjson?.deliverytimeslot?.name ||
      '';
  
    return slotName.toLowerCase().includes('express');
  }
  
  getPerDeliveryTotal(): number {
    const base =
      (this.order?.debugjson?.cart?.total || 0) +
      (this.order?.delivery_charge || 0);
  
    // ✅ ONLY for single-order page add express
    if (!this.isCheckoutLike() && this.isExpressDelivery()) {
      return base + 99;
    }
  
    // ✅ checkout/thankyou uses grand total method instead
    return base;
  }
  
  // getFinalCheckoutTotal(): number {
  //   // ✅ checkout/thankyou => correct overall total
  //   if (this.isCheckoutLike()) {
  //     return this.getCheckoutGrandTotal();
  //   }
  
  //   // ✅ orders page => single delivery total
  //   return this.getPerDeliveryTotal();
  // }
  
  
  // isCheckoutLike(): boolean {
  //   return this.isCheckoutPage || this.initpayment || this.isThankYouPage;
  // }
  
  getDiscountValue(): number {
    const dj = this.order?.debugjson;
    const coupons = dj?.cart?.coupon_code || [];
    const offers  = dj?.cart?.offer_code || [];
  
    return [...coupons, ...offers].reduce((sum: number, x: any) => {
      return sum + Number(x?.discount_value || 0);
    }, 0);
  }
  
   getBasePerDeliveryAfterDiscount(): number {
    const dj = this.order?.debugjson;
  
    // ✅ BEST: backend snapshot already contains this per delivery after coupon + delivery
    const cartFinal = Number(dj?.cart_finaltotal || 0);
    if (cartFinal) return cartFinal; // ex: 887
  
    // fallback compute
    const itemTotal = Number(dj?.cart?.total || 0);
    const delivery = Number(this.order?.delivery_charge || 0);
    const discount = this.getDiscountValue();
  
    return (itemTotal - discount) + delivery;
  }
  
  getExpressCount(): number {
    const schedules = this.order?.debugjson?.all_schedules || [];
    return schedules.filter((s: any) =>
      (s?.slot_name || '').toLowerCase().includes('express')
    ).length;
  }
  
  getExpressAmount(): number {
    // ✅ On orders page show only this order's express (not all schedules)
    if (this.isOrdersPage()) {
      return this.isExpressDelivery() ? 99 : 0;
    }
  
    // ✅ On checkout/thankyou show combined express count
    if (this.isCheckoutLike()) return this.getExpressCount() * 99;
  
    // fallback
    return this.isExpressDelivery() ? 99 : 0;
  }
  
  
  getCheckoutGrandTotal(): number {
    const schedules = this.order?.debugjson?.all_schedules || [];
    const deliveriesCount = schedules.length || 1;
  
    const base = this.getBasePerDeliveryAfterDiscount(); // 887
    const express = this.getExpressCount() * 99;         // 99
  
    return (base * deliveriesCount) + express;           // 1873
  }
  getFinalCheckoutTotal(): number {
    // ✅ MOST IMPORTANT FIX
    // On /orders ALWAYS show per-delivery total, never order.finaltotal
    if (this.isOrdersPage()) {
      return this.getPerDeliveryFinalBill();   // ✅ 887 / 986
    }
  
    // ✅ Checkout/Thankyou -> show grand total
    if (this.isCheckoutLike()) {
      return Number(this.order?.finaltotal || this.getCheckoutGrandTotal());
    }
  
    // Single order page fallback
    return Number(this.order?.finaltotal || this.getPerDeliveryFinalBill());
  }
  
  
  isCheckoutLike(): boolean {
    return this.isCheckoutPage || this.isThankYouPage; // ✅ NO initpayment here
  }
  
   isOrdersPage(): boolean {
    return this.router.url.includes('/orders');
  }
  
   getPerDeliveryFinalBill(): number {
    const base = this.getBasePerDeliveryAfterDiscount();  // uses cart_finaltotal (887)
    const express = this.isExpressDelivery() ? 99 : 0;    // only if THIS order is express
    return base + express;                                // 887 or 986
  }
  
}
